const getContext = require('airship/modules/page-context')
const getUiUrl = require('airship/modules/ui-url')
const Ractive = require('airship/modules/ractive')

const ractiveModal = require('airship/widgets/ractive-modal')

const template = require('./index.ract')
const modalTemplate = require('./template.ract')

module.exports = function createNotifyWidget(el) {
  const pageContext = getContext()
  const modal = ractiveModal(modalTemplate, {
    data: {
      uiUrl: getUiUrl()
    }
  })

  const view = new Ractive({
    el,
    template,
    data: {
      channel: null,
      sdk: null
    }
  })

  UA.then(sdk => {
    view.set({sdk: sdk, channel: sdk.channel})

    sdk.addEventListener('channel', ev => view.set({channel: ev.channel}))
  })

  view.on('show-modal', () => modal.open())

  modal.view.on('subscribe', () => {
    UA.then(sdk => {
      sdk.register().then(channel => {
        channel.namedUser.set(
          `${pageContext.context_processors.current_company.namedUserId}`
        )
      })
    })

    modal.close()
  })
}
